import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

export default function LanguageSwitcher({ variant = "dark" }) {
  const { locale, setLocale } = useI18n();
  const isDark = variant === "dark";

  const base =
    "text-[11px] uppercase tracking-[0.22em] font-medium transition-colors duration-300";
  const active = isDark ? "text-[hsl(var(--ink))]" : "text-[hsl(var(--bg))]";
  const inactive = isDark
    ? "text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--ink))]"
    : "text-[hsl(var(--bg))]/60 hover:text-[hsl(var(--bg))]";

  return (
    <div className="flex items-center gap-2" data-testid="language-switcher">
      <button
        type="button"
        aria-label="Switch to English"
        onClick={() => setLocale("en")}
        className={`${base} ${locale === "en" ? active : inactive}`}
        data-testid="lang-en"
      >
        EN
      </button>
      <span className={isDark ? "text-[hsl(var(--line))]" : "text-[hsl(var(--bg))]/30"}>/</span>
      <button
        type="button"
        aria-label="Passa all'italiano"
        onClick={() => setLocale("it")}
        className={`${base} ${locale === "it" ? active : inactive}`}
        data-testid="lang-it"
      >
        IT
      </button>
    </div>
  );
}
